import React from 'react';
import { profile } from '../data/profile';

function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} {profile.name}
    </footer>
  );
}

export default Footer;
